import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noIssues: {
		id: 'issue-navigator.common.empty-list-icon.no-issues',
		defaultMessage: 'No issues were found matching your search',
		description: 'This message is displayed when no issues matched the search criteria',
	},
	noIssuesIssueTermRefresh: {
		id: 'issue-navigator.common.empty-list-icon.no-issues-issue-term-refresh',
		defaultMessage: "There's nothing matching your search",
		description: 'This message is displayed when no issues matched the search criteria',
	},
});
export default messages;
